import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';
import { InputBaseProps } from '@mui/material/InputBase/InputBase';
import { OverridableStringUnion } from '@mui/types';
import { TextFieldPropsSizeOverrides } from '@mui/material/TextField/TextField';

export const operationBar: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 2,
};

export const noBoxShadow: SxProps = {
  boxShadow: 'none',
};

export const SxWidth: SxProps = {
  width: '100%',
};

export const MarginTop: CSSProperties = {
  marginTop: 1,
};

export const MarginTextTop: CSSProperties = {
  marginTop: 7,
};

export const BaseSize: InputBaseProps = {
  size: 'small',
};

export const BaseTextFieldSize:'small' = 'small';

// OverridableStringUnion<'small' | 'medium', InputBasePropsSizeOverrides>

export const BaseOverflow:SxProps = {
  overflow: 'auto',
  maxHeight: '770px',
};
